import {
    createBaseThemeOptions,
    createUnifiedTheme,
    palettes,
  } from '@backstage/theme';
  
  export const myTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
      palette: {
        ...palettes.dark
      }
    }),
    fontFamily: 'Arial, sans-serif',
    defaultPageTheme: 'home',
    components: {
      BackstageHeader: {
        styleOverrides: {
          header: ({ theme }) => ({
            width: 'auto',
            boxShadow: 'none',
            borderBottom: `3px solid ${theme.palette.primary.main}`,
            backgroundColor: "#443e40",
            backgroundImage: 'none'
          }),
        },
      },
    }
  });